import type { Template } from "@/types";

export const PO_05_H1_V4: Template[] = [
{
    id: "po-05-h1v4-01",
    name: "PO 01 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 42, y: 238, width: 525, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 739, y: 155, width: 170, height: 266, rotation: 0, imageRotation: 0 },
            { id: "3", x: 739, y: 430, width: 170, height: 266, rotation: 0, imageRotation: 0 },
            { id: "4", x: 917, y: 155, width: 170, height: 266, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 430, width: 170, height: 266, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-02",
    name: "PO 02 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 42, y: 238, width: 525, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 657, y: 115, width: 373, height: 621, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1038, y: 115, width: 129, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1038, y: 325, width: 129, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1038, y: 535, width: 129, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-03",
    name: "PO 03 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 58, y: 133, width: 491, height: 341, rotation: 0, imageRotation: 0 },
        { id: "2", x: 58, y: 482, width: 159, height: 237, rotation: 0, imageRotation: 0 },
        { id: "3", x: 225, y: 482, width: 158, height: 237, rotation: 0, imageRotation: 0 },
        { id: "4", x: 391, y: 482, width: 158, height: 237, rotation: 0, imageRotation: 0 },
        { id: "5", x: 695, y: 95, width: 435, height: 648, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-04",
    name: "PO 04 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 52, y: 187, width: 275, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 335, y: 187, width: 222, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 335, y: 350, width: 222, height: 312, rotation: 0, imageRotation: 0 },
            { id: "4", x: 668, y: 235, width: 240, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 916, y: 235, width: 239, height: 380, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-05",
    name: "PO 05 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 62, y: 235, width: 240, height: 380, rotation: 0, imageRotation: 0 },
        { id: "2", x: 310, y: 235, width: 240, height: 380, rotation: 0, imageRotation: 0 },
        { id: "3", x: 660, y: 187, width: 275, height: 476, rotation: 0, imageRotation: 0 },
        { id: "4", x: 943, y: 187, width: 222, height: 314, rotation: 0, imageRotation: 0 },
        { id: "5", x: 943, y: 509, width: 222, height: 154, rotation: 0, imageRotation: 0 }     
    ],
},

{
    id: "po-05-h1v4-06",
    name: "PO 06 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 94, y: 100, width: 418, height: 649, rotation: 0, imageRotation: 0 },
            { id: "2", x: 660, y: 382, width: 504, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 660, y: 125, width: 163, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 830, y: 125, width: 163, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1001, y: 125, width: 163, height: 250, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-07",
    name: "PO 07 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_07.png",
    size: [1217, 851],
    style: {},
    slots: [    
        { id: "1", x: 29, y: 140, width: 173, height: 281, rotation: 0, imageRotation: 0 },
        { id: "2", x: 29, y: 429, width: 173, height: 281, rotation: 0, imageRotation: 0 },
        { id: "3", x: 210, y: 140, width: 173, height: 281, rotation: 0, imageRotation: 0 },
        { id: "4", x: 210, y: 429, width: 173, height: 281, rotation: 0, imageRotation: 0 },
        { id: "5", x: 391, y: 140, width: 797, height: 569, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-08",
    name: "PO 08 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 224, width: 578, height: 401, rotation: 0, imageRotation: 0 },
        { id: "2", x: 586, y: 224, width: 245, height: 401, rotation: 0, imageRotation: 0 },
        { id: "3", x: 972, y: 224, width: 245, height: 401, rotation: 0, imageRotation: 0 },
        { id: "4", x: 839, y: 224, width: 125, height: 197, rotation: 0, imageRotation: 0 },
        { id: "5", x: 839, y: 429, width: 125, height: 196, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h1v4-09",
    name: "PO 09 - H1V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h1_v4_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 224, width: 576, height: 401, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 584, y: 224, width: 246, height: 401, rotation: 0, imageRotation: 0 },
        { id: "3", x: 838, y: 224, width: 245, height: 401, rotation: 0, imageRotation: 0 },
        { id: "4", x: 1091, y: 224, width: 125, height: 197, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1091, y: 429, width: 125, height: 196, rotation: 0, imageRotation: 0 },
    ],
}
];